namespace SP {
    export interface HistoryShipmentInfo {
        id: string;
        toteName: string;
        toteColor: string;
        customer: string;
        recipientName: string;
        orderNo: string;
        time: string;
    }
}